export const initialState = {
    stats:'',
    claimsLoading:false,
    loading: false,
    claims: [],
    claims_pages:0
};
